/* eslint-disable import/prefer-default-export */
export const SET_ALERT = 'SET_ALERT';
export const SET_USER = 'SET_USER';
export const REMOVE_ALERT = 'REMOVE_ALERT';
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const REGISTER_FAIL = 'REGISTER_FAIL';
export const USER_LOADED = 'USER_LOADED';
export const AUTH_FAIL = 'AUTH_FAIL';
export const ADD_MOVIES = 'ADD_MOVIES';
export const GET_MOVIES = 'GET_MOVIES';
export const GET_MOVIE = 'GET_MOVIE';
export const MOVIES_ERROR = 'MOVIES_ERROR';
export const DELETE_MOVIE = 'DELETE_MOVIE';
export const UPDATE_MOVIE = 'UPDATE_MOVIE';
export const PROGRESS_FEED = 'PROGRESS_FEED';
